export function formatTime(time: string): string {
  if (!time) return '';
  return time.replace(/^(\d{2})(\d{2})$/, '$1:$2');
}

export function formatDate(date: string): string {
  if (!date) return '';
  return date.replace(/^(\d{2})(\d{2})(\d{4})$/, '$1/$2/$3');
}